"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = startSpeakingActivity;
exports.START_SPEAKING_ACTIVITY = void 0;
var START_SPEAKING_ACTIVITY = 'WEB_CHAT/START_SPEAKING';
exports.START_SPEAKING_ACTIVITY = START_SPEAKING_ACTIVITY;

function startSpeakingActivity() {
  return {
    type: START_SPEAKING_ACTIVITY
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3N0YXJ0U3BlYWtpbmdBY3Rpdml0eS5qcyJdLCJuYW1lcyI6WyJTVEFSVF9TUEVBS0lOR19BQ1RJVklUWSIsInN0YXJ0U3BlYWtpbmdBY3Rpdml0eSIsInR5cGUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSx1QkFBdUIsR0FBRyx5QkFBaEM7OztBQUVlLFNBQVNDLHFCQUFULEdBQWlDO0FBQzlDLFNBQU87QUFDTEMsSUFBQUEsSUFBSSxFQUFFRjtBQURELEdBQVA7QUFHRCIsInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IFNUQVJUX1NQRUFLSU5HX0FDVElWSVRZID0gJ1dFQl9DSEFUL1NUQVJUX1NQRUFLSU5HJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc3RhcnRTcGVha2luZ0FjdGl2aXR5KCkge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IFNUQVJUX1NQRUFLSU5HX0FDVElWSVRZXG4gIH07XG59XG5cbmV4cG9ydCB7IFNUQVJUX1NQRUFLSU5HX0FDVElWSVRZIH07XG4iXX0=